import React from "react";
import MainPageComponent from "../components/mainPage/MainPageComponent";

export default function MainPage() {
  return (
    <div>
      <MainPageComponent />
    </div>
  );
}
